import React from 'react'
// import Form from "../Contact/Form"

function FormHome() {
  return (
    <>
      <div className='w-full flex justify-center'>
        <div className='max-w-2xl p-5 mx-5 bg-white shadow-lg '>
            <h2 className='text-center'>Send Us A Message</h2>
            <div className='p-4'>
            <div class="elfsight-app-3e1b4f35-7e45-48d4-b673-0e4d471508fd"></div>
            </div>
        </div>
      </div>
    </>
  )
}

export default FormHome
